<template>
  <div class="technicianExamineNotice">
    <h1>平台技师照片审核标准及规则</h1>
    <p>1、照片审核通过的标准</p>
    <p>1.1、头像：本人高清正面半身免冠工装照最佳</p>
    <p>1.2、相册：本人高清全身生活照最佳</p>
    <img src="../assets/image/technicianExamineNotice/technician.jpg" alt="">
    <p>2、照片审核不通过的常见情况</p>
    <p>2.1、真人实拍作弊的照片一律不通过，必须对着技师本人的正脸自拍、实拍。</p>
    <p>2.2、上传非本人照的照片一律不通过，包括但不限于故意遮挡、合成照片、网络照片、美颜过度。</p>
    <p>2.3、展示效果不佳的照片一律不通过，包括但不限于照片模糊、背景杂乱、大头照、头像不完整。</p>
    <p>2.4、低俗色情敏感的照片一律不通过，包括但不限于露肩、露胸、露腿、露肌肉、露肚脐、秀身材。</p>
    <p>2.5、特定场景拍摄的照片一律不通过，包括但不限于酒店、酒吧、浴室、卧室、沙发、健身房。</p>
    <p>2.6、特定动作拍摄的照片一律不通过，包括但不限于吸烟、喝酒、摸胸、摸裆、吐舌头、咬嘴唇、吃香蕉。</p>
    <p>2.7、特定服饰拍摄的照片一律不通过，包括但不限于短裙、黑丝、校服、泳衣、吊带、背心、透装。</p> 
    <p>2.8、技师必须完成实名认证、真人认证以及上传行业从业资格证，否则一律审核不通过</p>
    <p>2.9、仍有其他问题的照片一律不通过，具体以平台审核人员审核为准。</p> 
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
@import url("../assets/style/rem.css");
.technicianExamineNotice {
    font-size: 0.28rem;
    padding: 0.3rem;
    color: #666;

    h1{
        text-align: center;
        margin-bottom: 0.3rem;
        color: #333;
        font-size: 0.42rem;
    }

    p{
        margin-bottom: 0.1rem;
    }

    img{
        width: 100%;
    }
}
</style>